import SearchErrorMessage from 'components/App/Pages/SearchPage/SearchErrorMessage'
import InvalidSearchMessage from 'components/App/Pages/SearchPage/InvalidSearchMessage'
import Spinner from '@groovehq/internal-design-system/lib/components/Spinner/Spinner'

import { getLength, isEmpty } from 'util/arrays'

import Options from './Options'
import NoResults from './NoResults'

import { styles } from '../styles'

const List = ({
  delayedTicketIds,
  hasMore,
  hasSearchErrored,
  ignoreTabEnter,
  isFetchingMoreSearch, // true if fetching results and fetched some already
  isQueryStringValid,
  onDown,
  onSelect,
  onUp,
  onLoadMore,
  searchTerm,
  searchResults,
  recentConversations,
  isLoadingRecentConversations,
}) => {
  if (hasSearchErrored)
    return (
      <div css={styles.errorContainer}>
        <SearchErrorMessage />
      </div>
    )

  if (!isQueryStringValid) {
    return (
      <div className="grui mb-8" css={styles.errorContainer}>
        <InvalidSearchMessage />
      </div>
    )
  }

  if (searchTerm) {
    if (isFetchingMoreSearch && getLength(searchResults) <= 0) {
      return <Spinner className="grui mt-14 mb-14" />
    }

    if (getLength(searchResults) <= 0) return <NoResults />

    return (
      <Options
        hasMore={hasMore}
        delayedTicketIds={delayedTicketIds}
        ignoreTabEnter={ignoreTabEnter}
        isLoadingMore={isFetchingMoreSearch}
        items={searchResults}
        loadMore={onLoadMore}
        onDown={onDown}
        onSelect={onSelect}
        onUp={onUp}
      />
    )
  }

  if (isLoadingRecentConversations) {
    return <Spinner className="grui mt-14 mb-14" />
  }

  if (isEmpty(recentConversations)) {
    return <NoResults />
  }

  return (
    <>
      {!isEmpty(recentConversations) && (
        <>
          <span className="flex grui ml-6 mt-5" css={styles.listHeader}>
            Recent conversations
          </span>
          <Options
            hasMore={false}
            hideCustomer
            delayedTicketIds={delayedTicketIds}
            ignoreTabEnter={ignoreTabEnter}
            items={recentConversations.map(conversation => ({
              id: conversation.number,
              state: conversation.state,
              titleLabel: conversation.title,
              updated_at: conversation.updatedAt,
            }))}
            onDown={onDown}
            onSelect={onSelect}
            onUp={onUp}
          />
        </>
      )}
    </>
  )
}

export default List
